import styles from "./ChallengeButton.module.scss";
import challengeAnim from "./icons/challenges.gif";
import { setAppContext } from "../../../redux/app.slice";
import { AppContext } from "../../Menu/MenuButton";
import { useNavigate } from "react-router-dom";
import { useTracking } from "../../../hooks/traking";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "../../../hooks";
import { setChallengeButtonBlinkState } from "../../../redux/ui";

export const ChallengeButton = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { trackClick } = useTracking('ChallengeButton');

    const shouldBlink = useSelector(store => store.ui.challengeButtonBlink);
    const [blink, setBlink] = useState(false);

    useEffect(() => {
        if (!shouldBlink) return;

        setBlink(true);

        const timer = setTimeout(() => {
            setBlink(false);
            dispatch(setChallengeButtonBlinkState(false));
        }, 3000);

        return () => clearTimeout(timer);
    }, [shouldBlink, dispatch]);

    const handler = () => {
        trackClick('click');
        dispatch(setAppContext(AppContext.Challenges));
        navigate(`/${AppContext.Challenges}/`);
    };

    return (
        <div
            className={`${styles.cont} ${blink ? styles.blink : ""}`}
            onClick={handler}
        >
            <div className={styles.button}>
                <span className={styles.text}>Испытания</span>
                <img src={challengeAnim} alt="challenge" />
            </div>
        </div>
    );
};
